
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":"18","height":"18","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Material-Icons"}},[_c('g',{attrs:{"id":"filter","fill":"#C2C6DC"}},[_c('path',{attrs:{"id":"Path","d":"M4 10h10V8H4z"}}),_c('path',{attrs:{"id":"Path_1_","d":"M2 4v2h14V4z"}}),_c('path',{attrs:{"id":"Shape","d":"M7 14h4v-2H7z"}})])])])
          )
        }
      }
    